export default __webpack_public_path__ + "static/media/pix_logo_grande.132e217c.svg";